import React, { useState } from 'react';
import Button from '../button/Button';
import './ContactForm.css';

const ContactForm = ({ theme }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // Track form submission with your analytics
    if (window.portfolioTracker) {
      window.portfolioTracker.trackCrossDomainEvent('contact_form_submit', {
        category: 'contact',
        label: 'contact_form',
        formData: {
          hasName: !!formData.name,
          hasEmail: !!formData.email,
          hasSubject: !!formData.subject,
          messageLength: formData.message.length
        }
      });
    }

    try {
      // Using Formspree for form handling
      const response = await fetch('https://formspree.io/f/mdklaveg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        
        // Track successful submission
        if (window.portfolioTracker) {
          window.portfolioTracker.trackCrossDomainEvent('contact_form_success', {
            category: 'contact',
            label: 'form_success'
          });
        }
      } else {
        setSubmitStatus('error');
        
        // Track failed submission
        if (window.portfolioTracker) {
          window.portfolioTracker.trackCrossDomainEvent('contact_form_error', {
            category: 'contact',
            label: 'form_error',
            error: 'response_not_ok'
          });
        }
      }
    } catch (error) {
      setSubmitStatus('error');
      
      // Track error
      if (window.portfolioTracker) {
        window.portfolioTracker.trackCrossDomainEvent('contact_form_error', {
          category: 'contact',
          label: 'form_error',
          error: error.message
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    handleSubmit(e);
  };

  return (
    <div className="contact-form-container">
      <div className="contact-form-header">
        <h2 style={{ color: theme.text }}>Get In Touch</h2>
        <p style={{ color: theme.secondaryText }}>
          Have a project in mind? Let's discuss how we can work together.
        </p>
      </div>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Full Name *"
              style={{ 
                color: theme.text,
                borderColor: theme.text + '33'
              }}
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Email Address *"
              style={{ 
                color: theme.text,
                borderColor: theme.text + '33'
              }}
            />
          </div>
        </div>

        <div className="form-group">
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            placeholder="Subject *"
            style={{ 
              color: theme.text,
              borderColor: theme.text + '33'
            }}
          />
        </div>

        <div className="form-group">
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="4"
            placeholder="Tell me about your project... *"
            style={{ 
              color: theme.text,
              borderColor: theme.text + '33'
            }}
          ></textarea>
        </div>

        <Button
          text={isSubmitting ? "Sending..." : "Send Message"}
          onClick={handleButtonClick}
          theme={theme}
          disabled={isSubmitting}
        />

        {submitStatus === 'success' && (
          <div className="status-message success">
            <i className="fas fa-check-circle"></i>
            Thank you! Your message has been sent successfully.
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="status-message error">
            <i className="fas fa-exclamation-circle"></i>
            Sorry, there was an error sending your message. Please try again.
          </div>
        )}
      </form>
    </div>
  );
};

export default ContactForm;